// extracted by mini-css-extract-plugin
module.exports = {"headerLink":"components-anteriorHeader-headerLink__headerLink--3Udv_"};